import { useStoreState } from "pullstate";
import UserGroupManagement from ".";
import Store from "../../utils/Store";
import Modal from "../common/Modal";
import { useTranslation } from "react-i18next";
import Toast from "../Toast";
import { useEffect } from "react";

const UserGroupModal = () => {
  const { t } = useTranslation();
  const { isVisible } = useStoreState(Store, (s) => ({
    isVisible: s.isUserGroupOpen,
  }));

  const onCloseModal = () => {
    Store.update((s) => {
      s.isUserGroupOpen = false;
    });
  };

  useEffect(() => {
    if (isVisible) {
      Toast.success("To Be Released in Future Updates")
    }
  }, [isVisible])

  return (
    <Modal
      title={t("setting_user")}
      onClose={onCloseModal}
      show={isVisible}
      className="flex flex-col w-full sm:w-7/12 lg:w-4/12 !h-auto max-h-[90%] sm:!max-h-[80%] overflow-hidden"
    >
      <div className="relative h-full w-full blur-sm">
        {/* Disabled for PDS */}
        <div className="absolute top-0 left-0 h-full w-full z-[999] flex items-center justify-center">
        </div>

        <UserGroupManagement isOpen={isVisible} />
      </div>
    </Modal>
  );
};

export default UserGroupModal;
